import { ReactElement } from 'react'
import LearningPathsV3 from '../learning-path'

export default (): ReactElement => <LearningPathsV3 />
